<template>
  <label :class="classes">
    <select
      class="dn-select__node"
      :name="name"
      :placeholder="placeholder"
      :autofocus="autofocus"
      :disabled="disabled"
      :readonly="readonly"
      :required="required"
      :tabindex="tabindex"
      v-model="inputValue"
      @focus="onFocus"
      @blur="onBlur"
    >
      <slot />
    </select>
    <span class="dn-select__icon">
      <dn-icon icon="arrow-down" />
    </span>
  </label>
</template>

<script>
export default {
  props: {
    value: {},
    name: String,
    placeholder: String,
    autofocus: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    required: Boolean,
    tabindex: String,
  },



  data() {
    return {
      lazyValue: this.value,
      isFocused: false,
    }
  },



  computed: {
    classes() {
      return {
        'dn-select': true,
        'dn-select--focused': this.isFocused,
        'dn-select--disabled': this.disabled,
      }
    },

    inputValue: {
      get() { return this.lazyValue },
      set(val) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },
  },



  watch: {
    value() {
      this.inputValue = this.value;
    },
  },



  methods: {
    onFocus(e) {
      this.isFocused = true;
      this.$emit('focus', e);
    },

    onBlur(e) {
      this.isFocused = false;
      this.$emit('blur', e);
    },
  },



  created() {
  },
}
</script>


// WEBPACK FOOTER //
// Select.vue?bfeb40d8